<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>   
    <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
    <div class="main-wrapper" :class="{'blur-content': this.isLoading}">

        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <div class="card-header">
                  <h4 style="margin-right: 5px" class="float-start">GSOFT</h4>
                    
                  <button
                    v-if="permision_role.method_read"
                      class="btn btn-primary float-end text-black fw-bolder btn-icon-text"
                    style="margin-right: 5px"
                    @click.prevent="downloadData()"
                  >
                      <i class="mdi mdi-cloud-download" style="font-size:1rem;color:white;vertical-align: middle;"></i>
                    {{ $t("downloadData") }} .xlsx
                  </button>


                    <button
                      class="btn btn-warning float-end text-black fw-bolder btn-icon-text"
                      style="margin-right: 5px"
                      @click.prevent="resetFilter()"
                    >
                      <i class="mdi mdi-refresh" style="font-size:1rem;color:white;vertical-align: middle;"></i>
                       {{ $t("reset_filter_txt") }}
                    </button>

                </div>

                <div class="card-body">
                  <vue-good-table
                    title="list-buffer-blujay-gsoft"
                    mode="remote"
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    :totalRows="totalRecords"
                    :line-numbers="true"
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true,
                      perPageDropdown: [10, 50, 100, 1000, 10000],
                      dropdownAllowAll: false,
                    }"
                    :rows="rows"
                    :columns="columns"
                   
                  >


                        <template slot="column-filter" slot-scope="{ column }">
                        
                            <span v-if="column.filterOptions.customFilter">


                                <span v-if="column.field =='created_at'">

                                <date-range-picker style="width:100%" @update="created_at_change" control-container-class="form-control" :locale-data="{format:'yyyy-mm-dd'}" v-model="created_at_dates" :opens="opens" :singleDatePicker="false" :timePicker24Hour="false" :timePicker="false" :showWeekNumbers="false">
                                    <div slot="header" slot-scope="header" class="slot">
                                    <a @click="clear_created_at_change()" class="float-end" style="margin-right: 5px;color:red;">{{ $t("clear_calender") }}</a> <span v-if="header.in_selection"> - {{ $t("in_selection") }}</span>
                                    <br>
                                    </div>
                                </date-range-picker>

                                </span>
                            
                            </span>
                        

                        </template>

                     <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                            <a
                              href="#"
                              v-if="permision_role.method_read"
                              title="Detail"
                              @click.prevent="
                                detailData(props.index, props.row)
                              "
                            >
                              <i class="mdi mdi-eye" style="font-size:16px"></i>
                              
                            </a>
                             
                      </span>
                      <span v-else-if="props.column.field == 'seq'">


                            <div v-if="props.row.seq > 0">
                                {{$t("success")}}
                            </div>
                            <div v-else>
                                {{$t("error")}}
                            </div>
                             
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from 'vue2-daterange-picker';

export default {
  name: "BlujayGsoftIndex",
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    DateRangePicker,
  },
  data() {
    return {
        opens:"center",
        locale:{
            format:"yyyy-mm-dd",
        
        },
        so_dates: {
            startDate: null,
            endDate: null
        },
        created_at_dates:{
            startDate: null,
            endDate: null
        },
        highlighted:{

            dates: [ // Highlight an array of dates
                new Date(),
            ],

        },
        created_at_from:"",
        created_at_to:"",
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role:[],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      columns: [
        {
          label: this.$t("id"),
          field: "buffer_id",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: "Filter By "+this.$t("id"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("order_no_txt"),
          field: "integration",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("order_no_txt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: this.$t("filename"),
          field: "filename",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("filename"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("statusTxt"),
          field: "seq",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: false,
            placeholder: this.$t("statusTxt"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: ["success","error"], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: this.$t("created_at"),
          field: "created_at",
          filterOptions: {
            enabled: true, // enable filter for this column
            customFilter: true,
            placeholder: this.$t("created_at"), // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

       
        {
          label: this.$t("action_txt"),
          field: "actions",
          sortable: false,
        filterOptions: {
            customFilter: false,
            enabled: false, 
        },
        },
      ],
      rows: [],
      statusDropdown:[{value:0,text:"error"},{alue:1,text:"success"}],
    };
  },
  watch: {},
  methods: {

    created_at_change(){

        if(this.created_at_dates.startDate && this.created_at_dates.endDate){
            this.created_at_from=this.$moment(String(this.created_at_dates.startDate)).format('YYYY-MM-DD');
            this.created_at_to=this.$moment(String(this.created_at_dates.endDate)).format('YYYY-MM-DD');
            this.loadItems()
        }

    },

    clear_created_at_change(){
        this.created_at_dates={
            startDate: null,
            endDate: null
        };
        this.created_at_from = ""
        this.created_at_to = ""
        this.loadItems()
    },

    downloadData() {
      const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/buffers/index";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";
 
      return this.$http
        .get(
          baseURI +
           `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&buffer_id=${this.serverParams.columnFilters.buffer_id}&filename=${this.serverParams.columnFilters.filename}&integration=${this.serverParams.columnFilters.integration}&seq=${this.serverParams.columnFilters.seq}&created_at_from=${this.created_at_from}&created_at_to=${this.created_at_to}&type=GSOFTBLUJAY&download=download`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
         
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },
    

    detailData(index, row) {
      var params = this.$onRandom(row.buffer_id);
      window.location.href = "/blujay/gsoft/detail/" + params;
    },

    resetFilter() {
      const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/buffers/index";
      this.isLoading = true;
      //var columnFilters = this.serverParams.columnFilters;

        this.serverParams.columnFilters.buffer_id   = "";
        this.serverParams.columnFilters.filename    = "";
        this.serverParams.columnFilters.integration = "";
        this.serverParams.columnFilters.seq         = "";
        this.created_at_from                        = ""
        this.created_at_to                          = ""

      return this.$http
        .get(
           baseURI,
          { timeout: 50000 })
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        }).catch((error) => {
              this.loading();
              
              if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
              }else{
                if(error.code == "ECONNABORTED"){
                  this.error("Please Check Your Internet Connection");
                }
          
                if (error.response) {
                  if(error.response.status === 422) {
                          this.errors = error.response.data.errors;
                          this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      console.log(error)
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
                }

              }
            });
    },
 
    // load items is what brings back the rows from server
    loadItems() {
      const baseURI = this.$settings.endPointBlujay + "api/new-dashboard/buffers/index";
      this.isLoading = true;
      //var columnFilters = this.serverParams.columnFilters;


      return this.$http
        .get(
           baseURI +
           `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&buffer_id=${this.serverParams.columnFilters.buffer_id}&filename=${this.serverParams.columnFilters.filename}&integration=${this.serverParams.columnFilters.integration}&seq=${this.serverParams.columnFilters.seq}&created_at_from=${this.created_at_from}&created_at_to=${this.created_at_to}&type=GSOFTBLUJAY`,
          { timeout: 1000000 })
        .then((response) => {
          this.isLoading = false;
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        }).catch((error) => {
              this.loading();
              
              if(error.code == "ECONNABORTED"){
                this.error(this.$t("check_internet_connection_txt"));
                
              }else{          
                if (error.response) {
                  if(error.response.status === 422) {
                          this.errors = error.response.data.errors;
                          this.resultError(error.response.data.errors);
                  }else if (error.response.status === 401) {
                      // this.logout();
                      console.log(error)
                  } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                  }else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                  }else{
                      this.$router.push('/page-not-found');
                  }
                }

              }
            });
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas     = this.$getUserInfo();
      this.detailUser     = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function(permision){
        if(permision.permission.controller == 'BlujayGsoftController'){
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if(!rolePermision.method_read){
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;

    },

    
    logout(){

        const baseURI = this.$settings.endPointBlujay + "user/logout";
        this.$http.get(baseURI, { timeout: 10000 }).then((response) => {
            
        console.log(response);

        });

        this.$logoutUser();
        window.location.href = '/';
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loading();
  },
};
</script>
<style scoped>
.blur-content{
  filter: blur(5px); 
}
</style>